import React from 'react';
import { Alert, Box, Button, CircularProgress, Tooltip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import type {
  ProcessDeliveryQueueAsyncResult,
  ProcessDeliveryQueueSyncResult,
} from '../services/firebaseFunctions';

interface DeliveryQueueProcessButtonProps {
  pendingCount: number;
  processing: boolean;
  onProcess: () => void;
  syncResult: ProcessDeliveryQueueSyncResult | null;
  processError: string | null;
  /** Permissão de edição do módulo `entregas_pendentes`, resolvida na página — mantém o componente prop-driven. */
  canManage: boolean;
  /** Aviso de sobreposição parcial de filtros (D8), já formatado com empresa/produto pela página. */
  overlapWarning?: string | null;
}

const DeliveryQueueProcessButton: React.FC<DeliveryQueueProcessButtonProps> = ({
  pendingCount,
  processing,
  onProcess,
  syncResult,
  processError,
  canManage,
  overlapWarning,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Tooltip title={canManage ? '' : 'Você não tem permissão de edição no módulo Entregas Pendentes.'}>
      <span>
        <Button
          variant="contained"
          color="primary"
          startIcon={processing ? <CircularProgress size={18} color="inherit" /> : <PlayArrowIcon />}
          disabled={!canManage || processing || pendingCount === 0}
          onClick={onProcess}
        >
          {processing ? 'Processando...' : 'Processar Entregas'}
        </Button>
      </span>
    </Tooltip>

    {processError && <Alert severity="error">{processError}</Alert>}

    {overlapWarning && <Alert severity="warning">{overlapWarning}</Alert>}

    {syncResult && (
      <Alert severity="success">
        Processamento concluído: {syncResult.resolved} resolvidos, {syncResult.stillPending} ainda
        pendentes, {syncResult.errors} erros ({syncResult.totalProcessed} itens).
      </Alert>
    )}
  </Box>
);

export default DeliveryQueueProcessButton;

export type { ProcessDeliveryQueueAsyncResult };
